import OrdemServicoReceberService from "@/services/OrdemServicoReceberService";

export const ordemServicoReceber = {
  namespaced: true,
  state: {
    ordemServicoReceber: {},
  },
  actions: {
    getOrdemServicoReceber({ commit }, payload) {
      return OrdemServicoReceberService.GetOrdemServicoReceber(payload).then(
        (ordemServicoReceber) => {
          return Promise.resolve(ordemServicoReceber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoReceber({ commit }, payload) {
      return OrdemServicoReceberService.PostOrdemServicoReceber(payload).then(
        (ordemServicoReceber) => {
          return Promise.resolve(ordemServicoReceber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoReceber({ commit }, payload) {
      return OrdemServicoReceberService.PutOrdemServicoReceber(payload).then(
        (ordemServicoReceber) => {
          return Promise.resolve(ordemServicoReceber);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoReceber({ commit }, payload) {
      return OrdemServicoReceberService.DeleteOrdemServicoReceber(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoReceberOData({ commit }, payload) {
      return OrdemServicoReceberService.GetOrdemServicoReceberOData(
        payload
      ).then(
        (ordemServicoReceber) => {
          return Promise.resolve(ordemServicoReceber);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoReceber;
